module.exports = __webpack_public_path__ + "img/SES_192422590.f0866016.jpg";